/**
 * Configure lazysizes before the lazysizes script
 */

window.lazySizesConfig = window.lazySizesConfig || {};

// Do not wait for onload event before loading nearby images
window.lazySizesConfig.loadMode = 3;
